import React from 'react';
import './Loader.css';

function Loader(props) {
	return (
		<div className='loader-wrapper'>
			<div className='loader is-loading' />
		</div>
	);
}

export default Loader;
